module.exports = __webpack_public_path__ + "img/p37.6579b974.png";